(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rsl-offer"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var f=document.querySelector('#rs-offer form[action*="/cart/add"]'); if(!f) return;
    var btn=f.querySelector('button[name=add]');
    import('@shopify/events').catch(function(){});
    f.addEventListener('submit',function(e){
      e.preventDefault(); e.stopImmediatePropagation();
      if(btn.disabled) return; btn.disabled=true;
      var label=btn.textContent; btn.textContent='Lägger i varukorgen…';
      import('@shopify/events').then(function(m){
        var fd=new FormData(f); fd.delete('return_to');
        var ids=[].map.call(document.querySelectorAll('cart-items-component[data-section-id]'),function(c){return c.dataset.sectionId;});
        if(ids.length) fd.append('sections',ids.join(','));
        var qty=Number(fd.get('quantity'))||1;
        var d=m.CartLinesUpdateEvent.createPromise();
        f.dispatchEvent(new m.CartLinesUpdateEvent({action:'add',context:'product',lines:[{merchandiseId:fd.get('id'),quantity:qty}],promise:d.promise}));
        return fetch('/cart/add.js',{method:'POST',body:fd,headers:{Accept:'application/json'}})
          .then(function(r){return r.json();})
          .then(function(res){
            return fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
              d.resolve({cart:m.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),detail:{items:cart.items,source:'product-form-component',itemCount:qty,sections:res.sections,didError:!!res.status}});
              if(!res.status){var td=document.querySelector('#shopify-section-cart-drawer-section theme-drawer'); if(td&&!td.isOpen) td.open();}
            });
          });
      }).catch(function(){ HTMLFormElement.prototype.submit.call(f); })
        .finally(function(){ btn.disabled=false; btn.textContent=label; });
    },true);
  })();
  (function(){
    var root=document.getElementById('rs-offer'); if(!root) return;
    var g=root.querySelector('[data-rsl-gallery]'), t=root.querySelector('[data-rsl-thumbs]'); if(!g||!t) return;
    var thumbs=t.querySelectorAll('.rsl-offer__thumb');
    thumbs.forEach(function(b,i){ b.addEventListener('click',function(){ g.scrollTo({left:i*g.clientWidth,behavior:'smooth'}); }); });
    var set=function(){ var i=Math.round(g.scrollLeft/g.clientWidth); thumbs.forEach(function(b,k){ b.classList.toggle('is-active',k===i); }); };
    g.addEventListener('scroll',function(){ window.requestAnimationFrame(set); },{passive:true});
  })();

  } catch(e) { console.error(e); }
})();
})();
